import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { BadgeColorTypeEnum } from '../../enum/badge-color-type.enum.model';
import { BadgeColorEnum } from '../../enum/badge-color.enum.model';
import { BadgeTypeEnum } from '../../enum/badge-type.enum.model';

@Component({
    selector: 'app-badge-generator',
    templateUrl: './badge-generator.component.html',
    styleUrls: ['./badge-generator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BadgeGeneratorComponent implements OnInit, OnChanges {
  @Input() badgeType: BadgeTypeEnum;
  @Input() badgeColorType: BadgeColorTypeEnum = BadgeColorTypeEnum.basic;
  @Input() badgeColor: BadgeColorEnum;
  @Input() badgeLabel: string;
  @Input() badgeText: string;
  @Input() badgeText2: string;
  @Input() badgeClass: string = '';
  @Input() badgeToolTip: string;
  /** Posizione del tooltip ('auto' | 'top' | 'right' | 'left' | ...). Default: comportamento ngbTooltip standard. */
  @Input() badgeToolTipPlacement = 'auto';
  @Input() badgeIcon: string;
  /** Posizione dell'icona nel badge status. Default 'left' = comportamento storico, invariato per gli usi esistenti. */
  @Input() badgeIconPosition: 'left' | 'right' = 'left';
  @Input() badgeLink: string;
  @Input() badgeFullWidth: boolean = true;
  @Input() badgeTrafficLight: BadgeColorEnum[] = [BadgeColorEnum.secondary, BadgeColorEnum.secondary, BadgeColorEnum.secondary];

  @Output() badgeClicked = new EventEmitter<void>();


  badgeColorEnum = BadgeColorEnum;
  badgeColorTypeEnum = BadgeColorTypeEnum;
  badgeTypeEnum = BadgeTypeEnum;

  internalBadgeClass = '';
  badgeTrafficLightInternalClass;
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    this.getBadgeClass();
  }

  ngOnInit(): void {
    this.getBadgeClass();
  }

  getBadgeClass() {
    if (this.badgeType !== BadgeTypeEnum.trafficLigth) {
      switch (this.badgeColorType) {
        case BadgeColorTypeEnum.basic:
        case BadgeColorTypeEnum.glow:
          this.internalBadgeClass = ` ${this.badgeColor?.toString() ? 'badge-' + BadgeColorEnum[Number(this.badgeColor)] : ''}  ${this.badgeFullWidth ? 'd-block' : ''}  ${this.badgeClass}`;
          break;
        case BadgeColorTypeEnum.light:
          this.internalBadgeClass = ` ${this.badgeColor?.toString() ? 'badge-light-' + BadgeColorEnum[Number(this.badgeColor)] : ''}  ${this.badgeFullWidth ? 'd-block' : ''} ${this.badgeClass}`;
          break;
        default:
          this.internalBadgeClass = ` ${this.badgeColor?.toString() ? 'badge-' + BadgeColorEnum[Number(this.badgeColor)] : ''}  ${this.badgeFullWidth ? 'd-block' : ''} ${this.badgeClass}`;
          break;
      }
    } else {
      this.badgeTrafficLightInternalClass = [];
      switch (this.badgeColorType) {
        case BadgeColorTypeEnum.basic:
        case BadgeColorTypeEnum.glow:
          for (let index = 0; index < 3; index++) {
            this.badgeTrafficLightInternalClass.push('badge-' + BadgeColorEnum[this.badgeTrafficLight[index]]);
          }
          break;
        case BadgeColorTypeEnum.light:
          for (let index = 0; index < 3; index++) {
            this.badgeTrafficLightInternalClass.push('badge-light-' + BadgeColorEnum[this.badgeTrafficLight[index]]);
          }
          break;
      }

    }

  }

  onBadgeClicked() {
    this.badgeClicked.emit();
  }

}
